import jspreadsheet from 'jspreadsheet-ce';
import 'jspreadsheet-ce/dist/jspreadsheet.css';

window.jspreadsheet = jspreadsheet;

export { jspreadsheet };
